// extracted by mini-css-extract-plugin
export default {"container":"Servicos_container__KP05u","conteudo":"Servicos_conteudo__Awrwi","imagem":"Servicos_imagem__KIJy4"};